import { missingOrderTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const collectionState = {
  ...commonState.default({ collection: true }),
  pagination,
};

const defaultState = {
  ...commonState.default(),
};

export const missingOrderList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const missingOrderUpdate = (state = defaultState, action) =>
  commonReducer(actionTypes.UPDATE, state, action);

export const missingOrderDownload = (state = defaultState, action) =>
  commonReducer(actionTypes.DOWNLOAD, state, action);
